import React, { Component } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { getRealLink, isMobile } from './utils/baseUtil';
import Index from './pages/index.js';
import Article from './pages/article.js';
import Deepnews from './pages/deepnews';
import Contact from './pages/contact';
import NoMatch from './components/NoMatch';
import Expert from './pages/expert';
import Live from './pages/live';
import LiveIndex from './pages/live_index';
import QaPerson from './pages/qa_person';
import QaPersonAuthentication from './pages/qa_person_authentication';
import QaPersonResult from './pages/qa_person_result';
import QaViewpoint from './pages/qa_viewpoint';
import QaQa from './pages/qa_qa';
import StudentLiveIndex from './pages/student_live_index';
import StudentLiveList from './pages/student_live_list';
import Telegraph from './pages/telegraph';
import Topic from './pages/topic';
import Explain from './pages/explain';
import PersonVideo from './pages/personVideo';
import Tag from './pages/tag.js';
import Collection from './pages/collection.js';
import Subject from './pages/subject.js';
import Proficient from './pages/proficient';
import Openapp from './pages/openapp';

// 手机端与电脑端地址映射关系
// const addressMapping = {
//   deepnews:'article',
//   expert:"allExpert",
//   qa_proficient:"homepage",
//   qa_question:"answer",
//   qa_viewpoint:"viewPoint",
//   telegraph:"news",
//   topic:"subject",
//   explain:"interpret",
// }
const dev = process.env.NODE_ENV !== 'production';
const routeList = [
  {
    path: '/resources/html/article.html',
    component: Article
  },
  {
    path: '/resources/html/deepnews.html',
    component: Deepnews
  },
  {
    path: '/resources/html/contact.html',
    component: Contact
  },
  {
    path: '/resources/html/expert.html',
    component: Expert
  },
  {
    path: '/resources/html/live.html',
    component: Live
  },
  {
    path: '/resources/html/live_index.html',
    component: LiveIndex
  },
  {
    path: '/resources/html/qa_result.html',
    component: QaPersonResult
  },
  {
    path: '/resources/html/qa_viewpoint.html',
    component: QaViewpoint
  },
  {
    path: '/resources/html/student_live_index.html',
    component: StudentLiveIndex
  },
  {
    path: '/resources/html/student_live_list.html',
    component: StudentLiveList
  },
  {
    path: '/resources/html/telegraph.html',
    component: Telegraph
  },
  {
    path: '/resources/html/topic.html',
    component: Topic
  },
  {
    path: '/resources/html/explain.html',
    component: Explain
  },
  {
    path: '/resources/html/person_video.html',
    component: PersonVideo
  },
  {
    path: '/resources/html/collection.html',
    component: Collection
  },
  {
    path: '/resources/html/tag.html',
    component: Tag
  },
  {
    path: '/resources/html/subject.html',
    component: Subject
  },
  {
    path: '/pr/:id',
    component: Proficient
  },
  {
    path: '/resources/html/qa_answer.html',
    component: QaQa,
    props: {
      isAnswer: true
    }
  },
  {
    path: '/resources/html/qa_proficient.html',
    component: QaPerson,
    props: {
      type: 'proficient'
    }
  },
  {
    path: '/resources/html/qa_question.html',
    component: QaQa,
    props: {
      isAnswer: false
    }
  },
  {
    path: '/resources/html/qa_reporter.html',
    component: QaPerson,
    props: {
      type: 'reporter'
    }
  },
  {
    path: '/resources/html/qa_lanjing.html',
    component: QaPerson,
    props: {
      type: 'lanjing'
    }
  },
  {
    path: '/resources/html/qa_authentication.html',
    component: QaPersonAuthentication
  },
  {
    path: '/article/:id',
    pathFlag: 'article',
    component: Deepnews
  },
  {
    path: '/d/:id',
    pathFlag: 'd',
    component: Deepnews,
    jump: true
  },
  {
    path: '/app/share/news/:id',
    pathFlag: 'article',
    component: Deepnews
  },
  {
    path: '/allExpert',
    pathFlag: 'allExpert',
    component: Expert
  },
  {
    path: '/homepage/:id',
    pathFlag: 'homepage',
    component: QaPerson,
    props: {
      type: 'proficient'
    }
  },
  {
    path: '/answer/:id',
    pathFlag: 'answer',
    component: QaQa,
    props: {
      isAnswer: true
    }
  },
  {
    path: '/viewPoint/:id',
    pathFlag: 'viewPoint',
    component: QaViewpoint
  },
  {
    path: '/news/:id',
    pathFlag: 'news',
    component: Telegraph
  },
  {
    path: '/subject/:id',
    pathFlag: 'subject',
    component: Topic
  },
  {
    path: '/interpret/:id',
    pathFlag: 'interpret',
    component: Explain
  },
  {
    path: '/',
    component: Index,
    pathFlag: '',
    jump: true
  }
];
const exactRouteList = [
  {
    path: '/de/:id',
    link: 'deepnews'
  },
  {
    path: '/te/:id',
    link: 'telegraph'
  },
  {
    path: '/to/:id',
    link: 'topic'
  },
  {
    path: '/su/:id',
    link: 'subject'
  },
  {
    path: '/ar/:id',
    link: 'article'
  },
  {
    path: '/li/:id',
    link: 'live'
  },
  {
    path: '/co/:id',
    link: 'collection'
  },
  {
    path: '/ta/:id',
    link: 'tag'
  }
];
class Router extends Component {
  render() {
    return (
      <BrowserRouter>
        <Switch>
          {routeList.map((i) => (
            <Route
              key={i.path}
              path={i.path}
              exact
              render={(history) => {
                if (i.path.includes('qa_authentication.html')) {
                  const token =
                    !!history && !!history.location && !!history.location.state && !!history.location.state.token
                      ? history.location.state.token
                      : '';
                  const type =
                    !!history && !!history.location && !!history.location.state && !!history.location.state.type
                      ? history.location.state.type
                      : '';
                  const phone =
                    !!history && !!history.location && !!history.location.state && !!history.location.state.phone
                      ? history.location.state.phone
                      : '';
                  return !!token && !!type && !!phone ? (
                    <i.component type={type} phone={phone} />
                  ) : (
                    <Redirect to={!!type ? `/resources/html/qa_${type}.html` : '/'} />
                  );
                }
                if (i.path.includes('html')) {
                  return <i.component {...i.props} />;
                }
                if (!i.path.includes('html')) {
                  if (i.jump) {
                    if (isMobile()) {
                      return <i.component {...i.props} />;
                    } else {
                      // const id = history.location.search ? history.location.search.split('=')[1]:history.match.params.id
                      const id = history.match.params.id || '';
                      if (dev || window.location.host.indexOf('t-') > -1) {
                        window.location.href = id
                          ? `https://t-www.lanjinger.com/${i.pathFlag}/${id}`
                          : `https://t-www.lanjinger.com/${i.pathFlag}`;
                      } else {
                        window.location.href = id
                          ? `https://www.lanjinger.com/${i.pathFlag}/${id}`
                          : `https://www.lanjinger.com/${i.pathFlag}`;
                      }
                    }
                  } else {
                    return <i.component {...i.props} />;
                  }
                }
              }}
            />
          ))}
          {exactRouteList.map((i) => (
            <Route
              key={i.path}
              exact
              path={i.path}
              render={(history) => {
                window.location.href = getRealLink(history, i.link);
              }}
            />
          ))}
          <Route path="/openapp/open.html" component={Openapp} />
          <Route component={NoMatch} />
        </Switch>
      </BrowserRouter>
    );
  }
}

export default Router;